module.exports = __webpack_public_path__ + "media/assets/baseline-remove_circle-24px-edec7890.svg";